import script from "./CoordinationRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./CoordinationRecords.vue?vue&type=script&setup=true&lang=js"

import "./CoordinationRecords.vue?vue&type=style&index=0&id=e20ef0ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e20ef0ce"]])

export default __exports__